import type { PaletteInput } from './contracts';
import { generateRouteProp } from './index';
import { ROUTE_PROP_RECIPES } from './generatedRouteRecipeData';
import type { RoutePropTemplate } from './generatedRoutePropTemplates';

/** Existing buildTownTemplateBody's dispatch calls this. It returns body only;
 * generatePropSVG still owns the SVG frame/density, and NatureLayer owns placement. */
export function buildRouteTemplateBody(template: RoutePropTemplate, palette: PaletteInput): string {
  const recipe = ROUTE_PROP_RECIPES.find(value => value.template === template);
  if (!recipe) throw new Error(`Unknown route template: ${template}`);
  return generateRouteProp(recipe, palette).body;
}
